import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import { IconButton, ICON_TYPE } from '../../components/font-icons/IconButton'
import * as actions from '../../store/actions';
import Slider from 'rc-slider';

import 'rc-slider/assets/index.css';
import './style.scss';

import {
  getTextSettingsVisibiility,
  getCurrentTheme,
} from '../../store/selectors/selectors'
class TextSettingsSidebar extends Component {

  static defaultProps = {
    themes: [
      'theme-white',
      'theme-black',
      'theme-light',
    ]
  }
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    }
  };

  onHide() {
    this.setState({ isVisible: false });
  }

  onFontSizeChange(val) {

  }

  closeSettings = () => {
    this.props.toggleTextSettings(false);
  }

  onBgColorChange(theme) {
    this.props.toggleTextPlayerTheme(theme);
  }

  onReset() {
    this.props.toggleTextPlayerTheme('theme-black');
  }

  render() {
    const { currentTheme } = this.props;
    return (
      <div>
        <div
          className={cx(
            'text-settings-overllay',
            { hidden: !this.props.isVisible }
          )}
          onClick={this.closeSettings}
        />

        <div className={cx('text-settings', { hidden: !this.props.isVisible })}>
          <div className="text-settings__title">
            <h3>Settings</h3>
            <div className="text-settings__close-btn">
              <IconButton
                type={ICON_TYPE.CLOSE}
                onClick={this.closeSettings}
              />
            </div>
          </div>
          {/* <div className="text-settings__font-family">
            Aa
            <div className="text-settings__font-name">
              San Francisco
            </div>
          </div> */}
          {/* <div className="text-settings__font-size">
            A-
            <Slider
              className="text-settings__size-slider"
              min={0}
              max={1}
              step={0.1}
              value={0}
              onChange={(e) => { this.onFontSizeChange(e) }}
            />
            A+
          </div> */}
          <div className="text-settings__theme">
            {this.props.themes.map(theme => (
              <div
                key={theme}
                className={
                  cx(
                    'text-settings__theme-btn',
                    `font-sample--${theme}`,
                    {
                      [ICON_TYPE.CHECK]: currentTheme === theme,
                      'inactive': currentTheme !== theme
                    }
                  )}
                onClick={() => this.onBgColorChange(theme)}
              />
            ))}

          </div>
          <div className="text-settings__reset">
            <button
              className="btn reset-btn"
              onClick={() => { this.onReset() }}
            >
              Return default settings
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isVisible: getTextSettingsVisibiility(state),
  currentTheme: getCurrentTheme(state),
})

export default connect(mapStateToProps, actions)(TextSettingsSidebar)


// WEBPACK FOOTER //
// ./src/containers/text-mode-settings/TextModeSettings.jsx